// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'acuminproMediumWebfont', 'acuminproMediumWebfont Fallback'"},"className":"__className_7a76d3","variable":"__variable_7a76d3"};